var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalBeds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.7778V11.8889C2 11.2995 2.23413 10.7343 2.65087 10.3175C3.06762 9.90079 3.63285 9.66667 4.22222 9.66667M4.22222 9.66667H19.7778M4.22222 9.66667V5.22222C4.22222 4.63285 4.45635 4.06762 4.8731 3.65087C5.28984 3.23413 5.85507 3 6.44444 3H17.5556C18.1449 3 18.7102 3.23413 19.1269 3.65087C19.5437 4.06762 19.7778 4.63285 19.7778 5.22222V9.66667M19.7778 9.66667C20.3671 9.66667 20.9324 9.90079 21.3491 10.3175C21.7659 10.7343 22 11.2995 22 11.8889V20.7778M2 18.5556H22",
    stroke: "#FA7B42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBeds);
export default __webpack_public_path__ + "static/media/total_beds.759be18c0b0ca7119a38dcd3fb918fef.svg";
export { ForwardRef as ReactComponent };